<script lang="ts">
  import { _ } from 'svelte-i18n';
</script>

<div class="vtmn-flex vtmn-flex-wrap vtmn-mb-5">
  <h1 class="vtmn-font-thin vtmn-my-10 vtmn-text-5xl vtmn-mx-auto vtmn-text-center">
    {$_('error.404')}
  </h1>
</div>
